import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  EditProjectResponse,
  GetProjectsForSidebarResponse,
  ListCardsResponseWithProjectName,
  ManageProjectRequest,
} from "tng-address-collection-shared/types/apiTypes.ts";
import { queryKeys } from "./queryKeys.ts";

export const useEditProjectCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (project: ManageProjectRequest, data: EditProjectResponse) => {
      queryClient.setQueryData(
        queryKeys.cardsInProject(project.id),
        (old: ListCardsResponseWithProjectName | undefined) =>
          old
            ? {
                ...old,
                projectDisplayName: project.displayName,
                projectInfoBox: project.infoBox,
                projectShepherds: data.projectShepherds,
              }
            : old,
      );
      queryClient.setQueryData(
        queryKeys.projects(),
        (old: GetProjectsForSidebarResponse | undefined) =>
          old
            ?.map((p) =>
              p.id === project.id
                ? { ...p, displayName: project.displayName }
                : p,
            )
            .sort((a, b) => a.displayName.localeCompare(b.displayName)),
      );
      queryClient.setQueryData(queryKeys.manageProject(project.id), project);
    },
    [queryClient],
  );
};
